import { Component } from "./Component"

export class StateComponent extends Component {
  static isStateComponent = true
}
